import { useEffect, useState } from "react"
import supabase from "../../utils/subabaseClient"

export default function useData(id) {
  const [group, setGroup] = useState({})
  const [expenses, setExpenses] = useState([])

  const fetchExpenseGroup = async () => {
    const { data, error } = await supabase
      .from("expense_groups")
      .select("*")
      .eq("id", id)
      .single()

    if (error) {
      console.error("Error fetching expense group:", error.message)
    } else {
      console.log("Expense group fetched successfully!")
      fetchExpenses(data)
      setGroup(data)
    }
  }

  const fetchExpenses = async (group) => {
    const { data: users, error: usersError } = await supabase
      .from("symfonia_users")
      .select("*")
      .in("auth_user_id", group.members)

    if (usersError) {
      console.error("Error fetching users:", usersError.message)
    } else {
      console.log("Users fetched successfully!")
    }

    const { data: expenses, error: expensesError } = await supabase
      .from("expenses")
      .select("*")
      .eq("group_id", group.id)
      .order("created_at", { ascending: true })

    if (expensesError) {
      console.error("Error fetching expenses:", expensesError.message)
    } else {
      console.log("Expenses fetched successfully!")

      const expensesWithUsers = expenses.map((expense) => {
        const user = (users || []).find(
          (user) => user.auth_user_id === expense.created_by
        )
        return {
          ...expense,
          user,
        }
      })
      setExpenses(expensesWithUsers)
    }
  }

  useEffect(() => {
    if (id) {
      fetchExpenseGroup()
    }
  }, [id])

  return {
    group,
    fetchExpenseGroup,
    expenses,
    fetchExpenses,
  }
}
